import IStepTwoModel from './IStepTwoModel';

const StepTwoModelInitialState: IStepTwoModel = {
  hazinesakht: null,
  metrazh: null,
  sakhteman: null,
  khodro: null,
  asasiyeVaLavazem: null,
};

export default StepTwoModelInitialState;
